import styled from "styled-components";

export const PersonEditText = styled.p`
  color: #7e7e7e;
  margin-bottom: 6px;
`